import { render, staticRenderFns } from "./myCertificateDetail.vue?vue&type=template&id=3bd2d1d2&scoped=true&"
import script from "./myCertificateDetail.vue?vue&type=script&lang=js&"
export * from "./myCertificateDetail.vue?vue&type=script&lang=js&"
import style0 from "./myCertificateDetail.vue?vue&type=style&index=0&id=3bd2d1d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd2d1d2",
  null
  
)

export default component.exports